export default __webpack_public_path__ + "static/media/kweak_m.84296fd3.jpg";